export const ROLES = {
	ADMIN:1,
	QUOTER:2,
	CLIENT:3,
}